module.exports = __webpack_public_path__ + "img/hultza_yes.ca0bceb7.png";